(()=>{
  "use strict";
  const CLASS_COLOR="bca-v2__color";
  const CLASS_SIZE="bca-v2__size";
  const CLASS_READY="bca-v2__ready";

  function normalize(value){
    return String(value||"").normalize("NFD").replace(/[\u0300-\u036f]/g,"").replace(/\s+/g," ").trim().toLowerCase();
  }

  function fieldIdentity(field){
    const legend=field.querySelector("legend,.form__label");
    const names=[...field.querySelectorAll("input,select")].map(input=>input.name||"").join(" ");
    const values=[...field.querySelectorAll("input")].map(input=>input.value||"").join(" ");
    return normalize([legend&&legend.textContent,names,values].join(" "));
  }

  function isDesignField(field,identity){
    return field.classList.contains("ba-design-picker") ||
      /\bdiseno\b|ver mas disenos|cavox|nivra|meron|baren|banix/.test(identity);
  }

  function classifyVariantFields(variants){
    const fields=[...variants.querySelectorAll("fieldset")];
    const unclassified=[];
    fields.forEach(field=>{
      field.classList.remove(CLASS_COLOR,CLASS_SIZE);
      const identity=fieldIdentity(field);
      if(isDesignField(field,identity))return;
      if(/\bcolor\b/.test(identity)){
        field.classList.add(CLASS_COLOR);
        return;
      }
      if(/\btalla\b|\btamano\b|\bmedida\b/.test(identity)){
        field.classList.add(CLASS_SIZE);
        return;
      }
      unclassified.push(field);
    });
    unclassified.forEach((field,index)=>{
      field.classList.add(index===0?CLASS_COLOR:CLASS_SIZE);
    });
    const hasDesign=fields.some(field=>isDesignField(field,fieldIdentity(field)));
    const designIsReady=Boolean(variants.querySelector("[data-bca-fixed-design]"))||!hasDesign||Boolean(variants.querySelector("fieldset.ba-design-picker .ba-design-options-grid"));
    variants.classList.toggle(CLASS_READY,designIsReady);
  }

  function installTransitionGuard(){
    if(document.getElementById("bca-v2-transition-guard"))return;
    const style=document.createElement("style");
    style.id="bca-v2-transition-guard";
    style.textContent=[
      ".product__info-container.bca-v2 variant-selects:not(.bca-v2__ready){visibility:hidden!important;pointer-events:none!important}",
      ".product__info-container.bca-v2 variant-selects[style*=\"display: none\"]{display:none!important;visibility:hidden!important;pointer-events:none!important}"
    ].join("");
    style.textContent+=".product__info-container.bca-v2.bca-v2--simple .product-form__buttons{display:block!important;height:auto!important;min-height:0!important;margin-top:0!important}.product__info-container.bca-v2.bca-v2--simple .product-form__submit{display:flex!important;width:100%!important;max-width:none!important;min-height:66px!important;height:66px!important;margin:0!important;border-radius:8px!important}";
    document.head.appendChild(style);
  }

  function arrange(root){
    const info=root.querySelector(".product__info-container");
    const variants=root.querySelector("variant-selects");
    const buttons=root.querySelector(".product-form__buttons");
    const qty=root.querySelector(".product-form__quantity");
    const options=buttons&&buttons.querySelector(".bca-options-pro");
    if(!info||!variants)return false;

    info.classList.add("bca-v2");
    const hasExtendedPurchase=Boolean(info.querySelector(".bca-options-pro__groups,.bca-options-pro__price"));
    info.classList.toggle("bca-v2--simple",Boolean(buttons&&!hasExtendedPurchase));
    variants.classList.add("bca-v2__variants");

    const title=info.querySelector(".product__title");
    const pricePanel=[...info.children].find(child=>child.querySelector&&child.querySelector(".price"));
    if(title&&pricePanel&&!title.contains(pricePanel)){
      pricePanel.classList.add("bca-title-price");
      title.appendChild(pricePanel);
    }

    const picker=variants.querySelector("fieldset.ba-design-picker");
    if(picker){
      const prompt=picker.querySelector(".ba-design-prompt");
      if(prompt&&!prompt.dataset.bcaSplit){
        prompt.innerHTML='<span class="bca-prompt__main">OPRIME AQUÍ PARA VER MÁS DISEÑOS <b>👇🏻</b></span>';
        prompt.dataset.bcaSplit="1";
      }
    }

    classifyVariantFields(variants);

    if(buttons&&qty&&options&&!buttons.dataset.bcaV2){
      buttons.insertBefore(qty,buttons.firstChild);
      buttons.dataset.bcaV2="1";
    }

    const submit=buttons&&buttons.querySelector(".product-form__submit");
    if(submit){
      submit.style.setProperty("background","#9cf400","important");
      submit.style.setProperty("color","#061006","important");
      submit.style.setProperty("font-size","19px","important");
      submit.style.setProperty("font-family","Arial Black, Arial, sans-serif","important");
      submit.style.setProperty("border","1px solid #9cf400","important");
      submit.style.setProperty("transition","transform 150ms ease, outline-color 150ms ease","important");
    }
    return true;
  }

  function arrangeAll(){
    document.querySelectorAll("product-info").forEach(arrange);
  }

  let scheduled=false;
  function scheduleArrange(){
    if(scheduled)return;
    scheduled=true;
    requestAnimationFrame(()=>{
      scheduled=false;
      arrangeAll();
    });
  }

  function settleArrange(){
    arrangeAll();
  }

  function init(){
    installTransitionGuard();
    settleArrange();
    if(window.MutationObserver){
      const observer=new MutationObserver(mutations=>{
        if(mutations.some(mutation=>mutation.addedNodes&&mutation.addedNodes.length))scheduleArrange();
      });
      observer.observe(document.body,{childList:true,subtree:true});
    }
    document.addEventListener("change",event=>{
      if(event.target&&event.target.closest&&event.target.closest("variant-selects"))settleArrange();
    },true);
    ["variant:change","product:variant-change","shopify:section:load"].forEach(name=>{
      document.addEventListener(name,settleArrange);
    });
  }

  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init,{once:true});
  else init();
})();
